@if(isLoading){
  <div class="mb-5 a-walai text-center form-signin" >
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
    <p class="mt-3">{{'Single Sign On'|translate}}</p>
  </div>
}@else{
  @if(errMsg!=''){
 <div class="mb-5 a-walai text-center form-signin" >

  <div class="alert alert-warning" role="alert">
    {{errMsg}}
  </div>

  <!-- btn Login again -->
 
  <button class="btn btn-primary btn-lg px-5 mb-2" (click)="clickLogin()"  >  {{'Single Sign On'|translate}}</button>

</div>
  }

}
